import moment from 'moment-timezone';
import config from '../../../../../../../../config';
import { isCompleted, isDraft, isRecurringCampaign, isScheduled } from '../../../../../campaign-utils';
export var formatRecurringInterval = function (frequency, interval) {
    if (frequency === 'MONTHLY') {
        return 'Monthly';
    }
    if (frequency === 'WEEKLY') {
        if (interval === 1)
            return 'Weekly';
        return "Every ".concat(interval, " Weeks");
    }
    return '';
};
var dateFormat = 'MMMM D, YYYY';
var dateTimeFormat = "".concat(dateFormat, ", ").concat(config.timeFormat);
export var formatCampaignDateTime = function (campaign, timezone) {
    if (isDraft(campaign)) {
        return '';
    }
    if (isRecurringCampaign(campaign)) {
        if (campaign.recurringEndDate === null)
            return 'Indefinitely';
        return "Ends ".concat(moment(campaign.recurringEndDate).format(dateFormat));
    }
    if (isScheduled(campaign)) {
        return moment.tz(campaign.scheduledAt, timezone).format(dateTimeFormat);
    }
    if (isCompleted(campaign)) {
        return moment.tz(campaign.completedAt, timezone).format(dateTimeFormat);
    }
    return '';
};
export var formatDateWithIntl = function (dateString, options, locale) {
    if (options === void 0) { options = {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
    }; }
    if (locale === void 0) { locale = 'en-US'; }
    var date = dateString instanceof Date ? dateString : new Date(dateString);
    return new Intl.DateTimeFormat(locale, options).format(date);
};
